import React, { useEffect } from "react";

import * as propTypes from "../../propTypes";
import isObjectKeyHasValue from "../../utilities/isObjectKeyHasValue";
import { searchTypeCopy } from "./constants/copy";
import profileDateCopy from "./utilities/profileDateCopy";
import * as S from "./styled";

export default function ProfileInfo({ userProfile }) {
  const getAnalyticsProfileParams = () => {
    const result = [];
    const userSearchTypes = {
      rent: 0,
      buy: 1,
      sell: 4,
      buy_sell: 5,
      browse: 2
    };

    if (userProfile.searchType !== null) {
      result.push(`search_type:${userSearchTypes[userProfile.searchType]}`);
    }

    if (userProfile.liveInNyc !== null) {
      result.push(`live_in_nyc:${userProfile.liveInNyc ? 1 : 0}`);
    }

    if (userProfile.firstTimeHomeBuyer !== null) {
      result.push(
        `first_time_home_buyer:${userProfile.firstTimeHomeBuyer ? 1 : 0}`
      );
    }

    return result.join("|");
  };

  useEffect(() => {
    if (getAnalyticsProfileParams().length)
      window.dataLayer[0].userProfiles = getAnalyticsProfileParams();
  });

  return (
    <>
      <S.ProfileInfoContainer>
        {userProfile.searchType ? (
          <>
            Helping you <b>{searchTypeCopy[userProfile.searchType]}</b>{" "}
            {profileDateCopy({
              moveDate:
                userProfile.buySellMoveDate || userProfile.rentalMoveInDate,
              searchType: userProfile.searchType
            })}
          </>
        ) : (
          <>What brings you here?</>
        )}{" "}
        <S.ProfileLink
          href={`/my/account_profile${
            isObjectKeyHasValue(userProfile) ? "" : "?source=homepage_web"
          }`}
        >
          Update profile
        </S.ProfileLink>
      </S.ProfileInfoContainer>
    </>
  );
}

ProfileInfo.propTypes = {
  userProfile: propTypes.profile.isRequired
};
